import { FormValues } from "../../types";
import { Session } from "./session-field";

/**
 * PreSubmission adaptor for GravityForms
 * @param values
 * @param context
 * @returns
 */
const preSubmissionAdaptor = (values: FormValues) => ({
    ...values,
    ...Object.entries(values).reduce((updates, [_, v]) => {
        if (v instanceof Session) {
            v.cancel();
            return updates;
        }
        return updates;
    }, {})
});

export { preSubmissionAdaptor };
